<div class="torch__stage">
  <div
    class="torch__viewport"
    [attr.data-qa]="'torch-capture-viewport'"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)"
  >
    <video
      #preview
      class="torch__preview"
      playsinline
      muted
      autoplay
      [style.transform]="'scale(' + (presenter.vm()?.previewScale ?? 1) + ')'"
      [attr.data-qa]="'torch-capture-preview'"
    ></video>
    @if (presenter.vm()?.zoomLabel; as label) {
      <span class="torch__zoom" aria-live="polite" [attr.data-qa]="'torch-capture-zoom'">{{ label }}</span>
    }
  </div>

  @if (presenter.vm(); as vm) {
    @if (vm.busyMessage; as message) {
      <div class="torch__busy" role="status" [attr.data-qa]="'torch-capture-busy'">
        <span class="torch__spinner" aria-hidden="true"></span>
        <p class="torch__busy-message">{{ message }}</p>
      </div>
    }

    <div class="torch__controls">
      <button type="button" class="torch__control" (click)="presenter.cancel()" [attr.data-qa]="'torch-capture-cancel'">
        {{ vm.cancelLabel }}
      </button>

      <button
        type="button"
        class="torch__shutter"
        [disabled]="vm.shutterDisabled"
        (click)="presenter.capture()"
        [attr.data-qa]="'torch-capture-shutter'"
      >
        <span class="torch__shutter-label">{{ vm.shutterLabel }}</span>
      </button>

      @if (vm.torch; as torch) {
        <button
          type="button"
          class="torch__control"
          [class.torch__control--active]="torch.pressed"
          [attr.aria-pressed]="torch.pressed"
          [disabled]="torch.disabled"
          (click)="presenter.toggleTorch()"
          [attr.data-qa]="'torch-capture-toggle'"
        >
          <jui-icon [name]="torch.icon" color="current" size="md" [isButton]="false" aria-hidden="true"></jui-icon>
          {{ torch.label }}
        </button>
      } @else {
        <span class="torch__control torch__control--placeholder" aria-hidden="true"></span>
      }
    </div>
  }
</div>
